import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static targets = ["item"]
  static values = { key: String }

  connect() {
    reactor(this)
    this.restore()
  }

  morph() {
    this.restore()
  }

  // Runs on the summary click, before the browser toggles the details.
  remember(event) {
    const item = event.currentTarget.closest("details")
    const state = this.read()
    state[item.dataset.disclosureId] = !item.open
    this.write(state)
  }

  restore() {
    const state = this.read()
    for (const item of this.itemTargets) {
      const open = state[item.dataset.disclosureId]
      if (open !== undefined) item.open = open
    }
  }

  read() {
    try {
      return JSON.parse(sessionStorage.getItem(this.storageKey)) || {}
    } catch {
      return {}
    }
  }

  write(state) {
    try {
      sessionStorage.setItem(this.storageKey, JSON.stringify(state))
    } catch {}
  }

  get storageKey() {
    return `disclosure:${this.keyValue}`
  }
}
